
import React, { useEffect, useState} from 'react';
import { BrowserRouter, Link, Route, Routes } from "react-router-dom";
import './App.css';

import Home from './views/home/Home';
import Governance from './views/governance/Governance';
import NftMarket from './views/nftMarket/NftMarket';
import Insurance from './views/insurance/Insurance'
import Bitcoin from './views/insurance/bitcoin/Bitcoin';
import Ethereum from './views/insurance/ethereum/Ethereum';
import {Navbar, NavDropdown, Nav, Container, Button, Form, Modal} from "react-bootstrap";
import { FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faHandPointRight, faUser, faQuestionCircle} from '@fortawesome/free-regular-svg-icons';

function App () {
  const [modalShowStep1, setModalShowStep1] = useState(false);
  const [modalShowStep2, setModalShowStep2] = useState(false);
  const onClickForStep1 = () => {
    setModalShowStep1(false);
    setModalShowStep2(true);
  };
  const onClickForStep2 = () => {
    setModalShowStep2(false);
  };
  function CreateAccountModal(props) {
    return (
      <Modal
        {...props}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header className='border-bottom-0'>
          <Modal.Title className='mx-auto mt-2' id="contained-modal-title-vcenter">
            <FontAwesomeIcon icon={faUser}  color="#0d6efd" className='mr-2' size="sm"></FontAwesomeIcon>Refer a Friend
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className='px-5 py-5'>
          <Form.Label htmlFor="basic-url" className='h6'>Share this Code and You will learn 10 % of Transaction Fees from every Person you Refer.</Form.Label>
          <Form.Label htmlFor="basic-url" className='mt-3'>Enter Referral ID Code</Form.Label>
          <Form.Control type="text" placeholder='esere034jswsl3' />
          <div className='mx-auto text-center mt-3'>
            <Button variant='outline-primary' onClick={onClickForStep1} className="px-5 mt-4">Show More</Button>
          </div>
        </Modal.Body>
      </Modal>
    );
  }
  function CreateAccountModalStep2(props) {
    return (
      <Modal
        {...props}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header className='border-bottom-0'>
          <Modal.Title className='mx-auto mt-2' id="contained-modal-title-vcenter">
            <FontAwesomeIcon icon={faUser}  color="#0d6efd" className='mr-2' size="sm"></FontAwesomeIcon>Refer a Friend
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className='px-4 py-5'>
          <Form.Label htmlFor="basic-url" className='h6'>Share this Code and You will learn 10 % of Transaction Fees from every Person you Refer.</Form.Label>
          <Form.Label htmlFor="basic-url" className='mt-3'>Enter Referral ID Code</Form.Label>
          <Form.Control type="text" placeholder='adderser3423234fgsdf' />
          <div className='card-deck mt-1'>
            <div className="card d-inline-block mt-3" style={{borderLeft:'5px solid #0069d9'}}>
                <div className="card-body px-2">
                    <p className="card-title" style={{fontSize:"12px"}}>Total # of People referred <FontAwesomeIcon icon={faQuestionCircle} color="green" className='ml-2' size="lg"></FontAwesomeIcon></p>
                    <p className="h6">200</p>
                </div>
            </div>
            <div className="card d-inline-block mt-3" style={{borderLeft:'5px solid #f6c358'}}>
                <div className="card-body px-2">
                    <p className="card-title" style={{fontSize:"12px"}}>Amount of Cimple earned <FontAwesomeIcon icon={faQuestionCircle} color="green" className='ml-2' size="lg"></FontAwesomeIcon></p>
                    <p className="h6">2500</p>
                </div>
            </div>
          </div>
          <Form.Label htmlFor="basic-url">ReferredByID</Form.Label>
          <Form.Control type="text" placeholder='213sdfkfiewr2132'/>
          <div className='mx-auto text-center mt-1'>
            <Button variant='outline-secondary' onClick={onClickForStep2} className="px-5 mt-4">Submit</Button>
          </div>
        </Modal.Body>
      </Modal>
    );
  }
  return (
    <div className="App">
      <BrowserRouter>
        <Navbar collapseOnSelect expand="lg" bg="dark" variant="dark">
          <Container fluid>
            <Navbar.Brand href="/">Go Prototype</Navbar.Brand>
            <Navbar.Toggle aria-controls="responsive-navbar-nav" />
            <Navbar.Collapse id="responsive-navbar-nav">
              <Nav className="me-auto">
                {/* <Nav.Link as={Link} to="/">Home</Nav.Link> */}
                <Nav.Link as={Link} to="/insurance">Insurance</Nav.Link>
                <Nav.Link as={Link} to="/governance">Governance</Nav.Link>
                <Nav.Link as={Link}  to="/nftMarket">NFT Market</Nav.Link>
              </Nav>
            </Navbar.Collapse>
            <Navbar.Collapse id="responsive-navbar-nav1" className="justify-content-end">
              <Navbar.Text style={{color:"#0d6efd"}}>
                Earn 10% of Tx Fees!:<FontAwesomeIcon icon={faHandPointRight} color="#0d6efd" size="lg"></FontAwesomeIcon> <Button variant='primary' onClick={()=> setModalShowStep1(true)} className="px-4 py-1"><FontAwesomeIcon icon={faUser}  color="white" className='mr-2' size="sm"></FontAwesomeIcon>Refer a Friend</Button>
              </Navbar.Text>
            </Navbar.Collapse>
          </Container>
        </Navbar>
        <Routes>
          <Route path="/governance" element={<Governance />} />
          <Route path="/insurance" element={<Insurance />}>
            <Route index element={<Bitcoin />} />
            <Route path="bitcoin" element={<Bitcoin />} />
            <Route path="ethereum" element={<Ethereum />} />
            {/* <Route path="*" element={<NoMatch />} /> */}
          </Route>
          <Route path="/nftMarket" element={<NftMarket />} />
          <Route path="/" exact element={<Governance />} />
        </Routes>
        <CreateAccountModal
          show={modalShowStep1}
          onHide={() => setModalShowStep1(false)}
        />
        <CreateAccountModalStep2
          show={modalShowStep2}
          onHide={() => setModalShowStep2(false)}
        />
      </BrowserRouter>
    </div>
  );
}
export default App;
